import { useState, useEffect } from "react";

const ManualCompletionRestriction = ({
    manualCompletionRestriction,
    saveMerchantManualCompletionRestriction,
}) => {
    const [enabled, setEnabled] = useState(false);
    const [lockTriggerWindowMinutes, setLockTriggerWindowMinutes] = useState(0);
    const [cooldownMinutes, setCooldownMinutes] = useState(10);
    const [error, setError] = useState("");

    useEffect(() => {
        setEnabled(!!manualCompletionRestriction?.enabled);
        setLockTriggerWindowMinutes(
            manualCompletionRestriction?.lockTriggerWindowMinutes ?? 0,
        );
        setCooldownMinutes(manualCompletionRestriction?.cooldownMinutes ?? 10);
    }, [manualCompletionRestriction]);

    const handleSave = () => {
        const triggerValue = Number(lockTriggerWindowMinutes);
        const cooldownValue = Number(cooldownMinutes);

        if (enabled) {
            if (!Number.isFinite(triggerValue) || triggerValue < 0 || triggerValue > 1440) {
                setError(
                    "Please enter a valid trigger window in minutes after order placement (0-1440)",
                );
                return;
            }
            if (!Number.isFinite(cooldownValue) || cooldownValue <= 0 || cooldownValue > 1440) {
                setError("Please enter a valid driver lock time in minutes (1-1440)");
                return;
            }
        }

        setError("");
        saveMerchantManualCompletionRestriction({
            enabled,
            lockTriggerWindowMinutes: triggerValue,
            cooldownMinutes: cooldownValue,
        });
    };

    return (
        <div className="row g-5 g-lg-10 mt-4">
            <div className="col p-0 mb-xl-10">
                <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                    Manual Order Completion Restriction
                </h1>

                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-1 fw-bold">
                                    Restrict Manual Order Completion
                                </h5>
                                <p className="text-muted mb-0">
                                    The "Mark as Completed" button is always available. When
                                    enabled, completing one of this merchant's orders too soon
                                    after it was placed locks the delivering driver out of
                                    manual completion for a set time.
                                </p>
                            </div>

                            <div className="form-check form-switch form-check-custom form-check-solid">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="manualCompletionRestrictionEnabled"
                                    checked={enabled}
                                    onChange={(e) => {
                                        setEnabled(e.target.checked);
                                        setError("");
                                    }}
                                />
                            </div>
                        </div>

                        <div className="mt-4">
                            <span
                                className={`badge ${enabled ? "badge-light-success" : "badge-light-danger"
                                    }`}
                            >
                                {enabled ? "Enabled" : "Disabled"}
                            </span>
                        </div>

                        {enabled && (
                            <div className="row mt-6">
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Lock Trigger Window (minutes)
                                    </label>
                                    <input
                                        type="number"
                                        min="0"
                                        max="1440"
                                        step="1"
                                        className="form-control"
                                        value={lockTriggerWindowMinutes}
                                        onChange={(e) => {
                                            setLockTriggerWindowMinutes(e.target.value);
                                            setError("");
                                        }}
                                    />
                                    <small className="text-muted">
                                        The "Mark as Completed" button always works. But if an
                                        admin uses it within this many minutes of the order
                                        being placed, the delivering driver gets locked.
                                        Completing it later than this is normal — no lock. Use
                                        0 to disable this trigger.
                                    </small>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label">
                                        Driver Lock Duration (minutes)
                                    </label>
                                    <input
                                        type="number"
                                        min="1"
                                        max="1440"
                                        step="1"
                                        className="form-control"
                                        value={cooldownMinutes}
                                        onChange={(e) => {
                                            setCooldownMinutes(e.target.value);
                                            setError("");
                                        }}
                                    />
                                    <small className="text-muted">
                                        When the lock is triggered, the delivering driver's
                                        manual completion action is locked for this many
                                        minutes.
                                    </small>
                                </div>
                                {error && (
                                    <div className="col-12">
                                        <small className="text-danger d-block mt-1">{error}</small>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="mt-6 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManualCompletionRestriction;